<template>
    <div ref="scrollTarget"></div>
    <section style="margin-top: 30px; margin-bottom: 100px;">
        <div class="container mt-4">
            <div class="row justify-content-center">
                <div class="col-md-6 col-sm-12">
                    <div style="background-color: gainsboro; padding: 15px; border-radius: 20px;">
                        <span style="font-weight: bold; color: black;">Sender Information</span>
                        <form>
                            <div class="row mb-4">
                                <div class="col-md">
                                    <div class="form-outline">
                                        <label></label>
                                        <input type="text" class="form-control" :placeholder="translate('first_name')"
                                            v-model="sender.first_name"
                                            :class="{ 'fill-out': sender.first_name, 'not-fill-out': !sender.first_name }">
                                    </div>
                                </div>
                                <div class="col-md">
                                    <div class="form-outline">
                                        <label></label>
                                        <input type="text" class="form-control" :placeholder="translate('last_name')"
                                            v-model="sender.last_name"
                                            :class="{ 'fill-out': sender.last_name, 'not-fill-out': !sender.last_name }">
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-md">
                                    <div class="form-outline">
                                        <label></label>
                                        <input type="text" class="form-control" placeholder="Company Name"
                                            v-model="sender.company_name"
                                            :class="{ 'fill-out': sender.company_name, 'not-fill-out': !sender.company_name }">
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4">
                                <div class="col-md">
                                    <div class="form-outline">
                                        <label></label>
                                        <input type="email" class="form-control" :placeholder="translate('email')"
                                            v-model="sender.email"
                                            :class="{ 'fill-out': sender.email, 'not-fill-out': !sender.email }">
                                    </div>
                                </div>
                                <div class="col-md">
                                    <div class="form-outline">
                                        <label></label>
                                        <input type="tel" ref="phoneInput" class="form-control"
                                            placeholder="02 808 15 44" v-model="sender.phone" maxlength="10"
                                            :class="{ 'fill-out': sender.phone, 'not-fill-out': !sender.phone }">
                                    </div>
                                </div>
                            </div>

                            <div class="input-group mb-3 align-items-center">
                                <input id="autocomplete" type="text" class="form-control"
                                    :placeholder="translate('search_address')">
                            </div>

                            <div class="row mb-4">
                                <div class="col-md">
                                    <div class="form-outline">
                                        <label></label>
                                        <input type="text" class="form-control" :placeholder="translate('number')"
                                            v-model="sender.number"
                                            :class="{ 'fill-out': sender.number, 'not-fill-out': !sender.number }">
                                    </div>
                                </div>
                                <div class="col-md">
                                    <div class="form-outline">
                                        <label></label>
                                        <input type="text" class="form-control" :placeholder="translate('street')"
                                            v-model="sender.street"
                                            :class="{ 'fill-out': sender.street, 'not-fill-out': !sender.street }">
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4">
                                <template v-if="$store.state.shipment.express">
                                    <div class="col-md">
                                        <div class="form-outline">
                                            <label></label>
                                            <input type="text" class="form-control"
                                                :placeholder="translate('postal_code')"
                                                v-model="$store.state.shipment.s_postal_code"
                                                style="background-color: gainsboro;" readonly>
                                        </div>
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="col-md">
                                        <div class="form-outline">
                                            <label></label>
                                            <input type="text" class="form-control"
                                                :placeholder="translate('postal_code')" v-model="sender.postal_code"
                                                :class="{ 'fill-out': sender.postal_code, 'not-fill-out': !sender.postal_code }">
                                        </div>
                                    </div>
                                </template>
                                <div class="col-md">
                                    <div class="form-outline">
                                        <label></label>
                                        <input type="text" class="form-control" :placeholder="translate('city')"
                                            v-model="sender.city"
                                            :class="{ 'fill-out': sender.city, 'not-fill-out': !sender.city }">
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4">
                                <div class="col-md">
                                    <div class="form-outline">
                                        <label></label>
                                        <input type="text" class="form-control" :placeholder="translate('state')"
                                            v-model="sender.state"
                                            :class="{ 'fill-out': sender.state, 'not-fill-out': !sender.state }">
                                    </div>
                                </div>
                                <div class="col-md">
                                    <div class="form-outline">
                                        <label></label>
                                        <input type="text" class="form-control" placeholder="Country"
                                            v-model="sender.country" style="background-color: gainsboro;" readonly>
                                    </div>
                                </div>
                            </div>
                            <button type="button" :onclick="UpdateSender" class="btn btn-success">Update</button>
                        </form>
                    </div>
                </div>
                <div class="col-md-6 col-sm-12">
                    <div style="background-color: #efefef; padding: 15px; border-radius: 20px;">
                        <span style="font-weight: bold; color: black;">Receiver Information</span>
                        <form>
                            <div class="row mb-4">
                                <div class="col-md">
                                    <div class="form-outline">
                                        <label></label>
                                        <input type="text" class="form-control" :placeholder="translate('first_name')"
                                            v-model="recipient.first_name"
                                            :class="{ 'fill-out': recipient.first_name, 'not-fill-out': !recipient.first_name }">
                                    </div>
                                </div>
                                <div class="col-md">
                                    <div class="form-outline">
                                        <label></label>
                                        <input type="text" class="form-control" :placeholder="translate('last_name')"
                                            v-model="recipient.last_name"
                                            :class="{ 'fill-out': recipient.last_name, 'not-fill-out': !recipient.last_name }">
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-md">
                                    <div class="form-outline">
                                        <label></label>
                                        <input type="text" class="form-control" placeholder="Company Name"
                                            v-model="recipient.company_name"
                                            :class="{ 'fill-out': recipient.company_name, 'not-fill-out': !recipient.company_name }">
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4">
                                <div class="col-md">
                                    <div class="form-outline">
                                        <label></label>
                                        <input type="email" class="form-control" :placeholder="translate('email')"
                                            v-model="recipient.email"
                                            :class="{ 'fill-out': recipient.email, 'not-fill-out': !recipient.email }">
                                    </div>
                                </div>
                                <div class="col-md">
                                    <div class="form-outline">
                                        <label></label>
                                        <input type="tel" ref="phoneInput" class="form-control"
                                            placeholder="02 808 15 44" v-model="recipient.phone" maxlength="10"
                                            :class="{ 'fill-out': recipient.phone, 'not-fill-out': !recipient.phone }">
                                    </div>
                                </div>
                            </div>

                            <div class="input-group mb-3 align-items-center">
                                <input id="autocomplete2" type="text" class="form-control"
                                    :placeholder="translate('search_address')">
                            </div>

                            <div class="row mb-4">
                                <div class="col-md">
                                    <div class="form-outline">
                                        <label></label>
                                        <input type="text" class="form-control" :placeholder="translate('number')"
                                            v-model="recipient.number"
                                            :class="{ 'fill-out': recipient.number, 'not-fill-out': !recipient.number }">
                                    </div>
                                </div>
                                <div class="col-md">
                                    <div class="form-outline">
                                        <label></label>
                                        <input type="text" class="form-control" :placeholder="translate('street')"
                                            v-model="recipient.street"
                                            :class="{ 'fill-out': recipient.street, 'not-fill-out': !recipient.street }">
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4">
                                <template v-if="$store.state.shipment.express">
                                    <div class="col-md">
                                        <div class="form-outline">
                                            <label></label>
                                            <input type="text" class="form-control"
                                                :placeholder="translate('postal_code')"
                                                v-model="$store.state.shipment.s_postal_code"
                                                style="background-color: gainsboro;" readonly>
                                        </div>
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="col-md">
                                        <div class="form-outline">
                                            <label></label>
                                            <input type="text" class="form-control"
                                                :placeholder="translate('postal_code')" v-model="recipient.postal_code"
                                                :class="{ 'fill-out': recipient.postal_code, 'not-fill-out': !recipient.postal_code }">
                                        </div>
                                    </div>
                                </template>
                                <div class="col-md">
                                    <div class="form-outline">
                                        <label></label>
                                        <input type="text" class="form-control" :placeholder="translate('city')"
                                            v-model="recipient.city"
                                            :class="{ 'fill-out': recipient.city, 'not-fill-out': !recipient.city }">
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4">
                                <div class="col-md">
                                    <div class="form-outline">
                                        <label></label>
                                        <input type="text" class="form-control" :placeholder="translate('state')"
                                            v-model="recipient.state"
                                            :class="{ 'fill-out': recipient.state, 'not-fill-out': !recipient.state }">
                                    </div>
                                </div>
                                <div class="col-md">
                                    <div class="form-outline">
                                        <label></label>
                                        <input type="text" class="form-control" placeholder="Country"
                                            v-model="recipient.country" style="background-color: gainsboro;" readonly>
                                    </div>
                                </div>
                            </div>
                            <button type="button" :onclick="UpdateRecipient" class="btn btn-success">Update</button>
                        </form>
                    </div>
                </div>
            </div>

            <div style="margin-top: 10px; font-weight: bold; font-style: italic;" class="notification is-warning">
                <p>NB: If you get an error saying "company name too long," check the company names for both the sender and receiver. If either is too long, try to shorten it slightly.</p>
                <p>NB: If you get an error saying "street name too long," check the street name (Number and Street Name fields) for both the sender and receiver. If it's too long, try to shorten it slightly.</p>
                <p>NB: If you get an error saying "service invalid," please change the transporter and try again.</p>
                <p>NB : Make sure to click the "Update" button when you change the sender or receiver information, before clicking the "Create AWB" button.</p>
            </div>
            <div class="row justify-content-center" style="margin-top: 30px;">
                <div class="col-md-8 col-sm-12 mb-4">
                    <div class="p-4 rounded text-center border">
                        <span style="font-weight: 600; color: black;">Create AWB for Shipment {{
                            this.$route.params.shipment_id
                        }}</span>
                        <form @submit.prevent="CreateAWBSHipment" style="margin-top: 20px;">
                            <div class="form-group mb-3">
                                <div class="row">
                                    <div class="col">
                                        <label class="label-control"
                                            style="color: black; font-weight: 600; margin-bottom: 5px;">Shipping
                                            Date</label>
                                        <input type="text" class="form-control" placeholder="Ex : 2024-12-27" required
                                            v-model="shipping_date">
                                    </div>
                                    <div class="col">
                                        <label class="label-control"
                                            style="color: black; font-weight: 600; margin-bottom: 5px;">Transporter</label>
                                        <select class="form-select" v-model="transporter">
                                            <option value="FEDEX">FEDEX</option>
                                            <option value="UPS">UPS</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="text-center mt-3">
                                <button type="submit" class="btn btn-login2 me-2">Create AWB</button>
                                <br>
                                <template v-if="error_message">
                                <div style="margin-top: 10px;" class="notification is-danger">
                                    <p>{{ error_message }}</p>
                                </div>
                            </template>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

        </div>
    </section>
</template>


<script>
import { AutocompletionEk } from '../autocompletion'
import axios from 'axios'
import { toast } from 'bulma-toast'
import 'intl-tel-input/build/css/intlTelInput.css';
import intlTelInput from 'intl-tel-input';
import Swal from 'sweetalert2'
import en from '../en.js';
import fr from '../fr.js';
import nl from '../nl.js';


export default {
    name: 'SignUp',
    mixins: [en, fr, nl],
    data() {
        return {
            sender: {},
            recipient: {},
            pickup_country_code: '',
            receiver_country_code: '',
            sender_response: {},
            shipping_date: "",
            transporter: "",
            delivery_date: "",
            error_message: "",
            errors: []
        }
    },
    computed: {
        lang() {
            return this.$store.state.lang
        },
    },
    async mounted() {
        document.title = 'Create AWB | Eurekali'
        const element = this.$refs.scrollTarget;
        element.scrollIntoView({ behavior: 'smooth' });
        window.scrollTo(0, 0);

        await axios.get(`/api/v1/admin/get-shipment-address/${this.$route.params.shipment_id}/`)
            .then(response => {
                this.pickup_country_code = response.data['pickup_country_code']
                this.receiver_country_code = response.data['receiver_country_code']
                this.sender = response.data['sender']
                this.recipient = response.data['recipient']

            })
            .catch(error => {
                console.log(error)
            })

        /********autocomplete1*********/
        var autocomplete = new AutocompletionEk(document.getElementById("autocomplete"),);
        autocomplete.setComponentRestrictions({ country: this.pickup_country_code });

        autocomplete.addListener("place_changed", () => {
            const place = autocomplete.getPlace();
            if (!place.address_components) {
                return;
            }

            let country = '';
            let postalCode = '';
            let state = '';
            let city = '';
            let number = '';
            let street = '';

            for (const component of place.address_components) {
                if (component.types.includes("country")) {
                    country = component.long_name;
                }
                if (component.types.includes("postal_code")) {
                    postalCode = component.long_name;
                }
                if (component.types.includes("administrative_area_level_1")) {
                    state = component.long_name;
                }
                if (component.types.includes("locality")) {
                    city = component.long_name;
                }
                if (component.types.includes("street_number")) {
                    number = component.long_name;
                }
                if (component.types.includes("route")) {
                    street = component.long_name;
                }
            }

            this.sender.postal_code = postalCode;
            this.sender.state = state;
            this.sender.city = city;
            this.sender.number = number;
            this.sender.street = street;
        });

        /********autocomplete2*********/
        var autocomplete2 = new AutocompletionEk(document.getElementById("autocomplete2"),);
        autocomplete2.setComponentRestrictions({ country: this.receiver_country_code });

        autocomplete2.addListener("place_changed", () => {
            const place = autocomplete2.getPlace();
            if (!place.address_components) {
                return;
            }

            let country = '';
            let postalCode = '';
            let state = '';
            let city = '';
            let number = '';
            let street = '';

            for (const component of place.address_components) {
                if (component.types.includes("country")) {
                    country = component.long_name;
                }
                if (component.types.includes("postal_code")) {
                    postalCode = component.long_name;
                }
                if (component.types.includes("administrative_area_level_1")) {
                    state = component.long_name;
                }
                if (component.types.includes("locality")) {
                    city = component.long_name;
                }
                if (component.types.includes("street_number")) {
                    number = component.long_name;
                }
                if (component.types.includes("route")) {
                    street = component.long_name;
                }
            }

            this.recipient.postal_code = postalCode;
            this.recipient.state = state;
            this.recipient.city = city;
            this.recipient.number = number;
            this.recipient.street = street;
        });
    },
    methods: {
        translate(prop) {
            return this[this.lang][prop];
        },
        async UpdateSender() {
            const formData = {
                client: this.sender
            }
            this.$store.commit('setIsLoading', true)
            await axios
                .post(`/api/v1/admin/update-client-infos/${this.sender.id}/`, formData)
                .then(response => {
                    Swal.fire({
                        icon: 'success',
                        title: 'Infos Updated',
                        text: '',
                        confirmButtonColor: '#4BB543'
                    });
                })
                .catch(error => {
                    this.$store.commit('setIsLoading', false);

                    let errorMessage = 'An unknown error occurred.';

                    if (error.response && error.response.data) {
                        errorMessage = error.response.data.error || JSON.stringify(error.response.data);
                    }
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: errorMessage,
                        confirmButtonColor: '#ff0e0e'
                    });
                })

            this.$store.commit('setIsLoading', false)
        },
        async UpdateRecipient() {
            const formData = {
                client: this.recipient
            }
            this.$store.commit('setIsLoading', true)
            await axios
                .post(`/api/v1/admin/update-client-infos/${this.recipient.id}/`, formData)
                .then(response => {
                    Swal.fire({
                        icon: 'success',
                        title: 'Infos Updated',
                        text: '',
                        confirmButtonColor: '#4BB543'
                    });
                })
                .catch(error => {
                    this.$store.commit('setIsLoading', false);

                    let errorMessage = 'An unknown error occurred.';

                    if (error.response && error.response.data) {
                        errorMessage = error.response.data.error || JSON.stringify(error.response.data);
                    }
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: errorMessage,
                        confirmButtonColor: '#ff0e0e'
                    });
                })
            this.$store.commit('setIsLoading', false)
        },
        async getDelivery_time() {
            const dataserv = {
                'shipment_id': this.$route.params.shipment_id,
                "ship_date": this.shipping_date,
            }

            await axios.post('/api/v1/get-delivery-date/', dataserv)
                .then(response => {
                    this.delivery_date = response.data['delivery_time']
                })
                .catch(error => {
                    console.log(error)
                })
        },
        async CreateAWBSHipment() {
            this.$store.commit('setIsLoading', true)
            await this.getDelivery_time()

            const dataserv = {
                "shipment_id": this.$route.params.shipment_id,
                "transporter": this.transporter,
                "ship_date": this.shipping_date,
                "delivery_date" : this.delivery_date
            }

            await axios.post('/api/v1/transporters/admin/create-awb/', dataserv)
                .then(response => {
                    this.error_message = ""
                    this.error_message = response.data['RequestMessage']
                    if (this.error_message === "AWB CREATED"){
                        const toPath = this.$route.query.to || '/shipments-progress'
                    this.$router.push(toPath)
                    }
                    
                })
                .catch(error => {
                    console.log(error)
                })
            this.$store.commit('setIsLoading', false)
        },
    }
}
</script>

<style>
.btn-login2 {
    background-color: #E5097F;
    color: white;
    margin-left: 15px;
    border-radius: 20px;
    font-weight: bold;
    padding-left: 25px;
    padding-right: 25px;
}

.btn-login2:hover {
    background-color: #9b0656;
    color: white;
}
</style>